<template>
  <div id="app">
    <v-touch v-on:swipeleft="goNextMonth" v-on:swiperight="goPrevMonth">
      <Title />
      <MonthsContainer />
    </v-touch>
    <Footer />
  </div>
</template>

<script>
import Vue from 'vue';
import MonthsContainer from './components/MonthsContainer.vue';
import Title from './components/Title.vue';
import Footer from './components/Footer.vue';

const VueTouch = require('vue-touch');

VueTouch.config.swipe = {
  direction: 'horizontal'
};

Vue.use(VueTouch, { name: 'v-touch' });

export default {
  name: 'app',
  components: {
    Title,
    MonthsContainer,
    Footer
  },
  methods: {
    goPrevMonth() {
      this.$store.dispatch('goBackward');
    },
    goNextMonth() {
      this.$store.dispatch('goForward');
    }
  }
};
</script>

<style lang="scss">

</style>
